import React from "react";

const ProfileModule = React.lazy(() => import("./ui/Profile"));

export const ProfilePage = () => {
  return <ProfileModule />;
};
